<script setup>
import Datatable from '@/components/Shared/Table/Datatable.vue';
import { inject } from 'vue';
import moment from 'moment';

const trans = inject('trans');

const props = defineProps({
  timeRegistrations: {
    type: Array,
    required: true,
  },
  hiddenColumns: {
    type: Array,
    default: null,
  },
});
const headers = [
  { text: trans('__JSON__.Logged At'), value: 'dateLogged', align: 'start' },
  { text: trans('__JSON__.Paid Service ID'), value: 'paidServiceId', align: 'start' },
  { text: trans('__JSON__.Logged By'), value: 'loggedBy.name', align: 'start' },
  { text: trans('__JSON__.Spent Hours'), value: 'spentHours', align: 'start' },
  { text: trans('__JSON__.Billable'), value: 'isBillable', align: 'center' },
  { text: trans('__JSON__.Description'), value: 'description', align: 'start' },
  { text: trans('__JSON__.Ticket ID'), value: 'ticketId', align: 'center' },
];

const getIconBillable = usage => (usage.isBillable ? 'check-circle-icon' : 'x-circle-icon');
const getIconClassBillable = usage => (usage.isBillable ? 'text-success' : 'text-danger');
</script>

<template>
  <div>
    <datatable :headers="headers" :hidden-columns="hiddenColumns" :items="timeRegistrations" :loading="false">
      <template #item-date-logged="{ item }">
        {{ moment(item.dateLogged).format('DD/MM/YYYY') }}
      </template>

      <template #item-is-billable="{ item }">
        <svg :class="getIconClassBillable(item)" class="icon icon_tile" style="width: 1.8rem; height: 1.8rem">
          <use :xlink:href="`#${getIconBillable(item)}`"></use>
        </svg>
      </template>

      <template #item-ticket-id="{ item }">
        <inertia-link :href="route('dashboard.support.show', item.ticketId)" class="link">
          {{ item.ticketId }}
        </inertia-link>
      </template>
    </datatable>
  </div>
</template>
